var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dev"},[_c('pre',{staticClass:"dev__output"},[_vm._v(_vm._s(_vm.output))]),_c('div',{staticClass:"dev__button-bar"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":_vm.exec}},[_vm._v("Execute")])])])}
var staticRenderFns = []

export { render, staticRenderFns }